
<div #console class="live-console">
  @for (message of messages; track message) {
    <div [class]="getClass(message.Severity)">
      {{ message.Timestamp }}: {{ message.Message }}
    </div>
  }
  <br /><br />
</div>